export default __webpack_public_path__ + "static/media/Tile.468afe0e.png";